import { sectionCardProps } from "@/components/cards/sectionCards";

export const faqCards: sectionCardProps[] = [
  {
    name: "How do I search for properties on Estatein?",
    description:
      "Learn how to use our user-friendly search tools to find properties that match your criteria.",
    buttonText: "Read More",
    disabled: true,
  },
  {
    name: "What documents do I need to sell my property through Estatein?",
    description:
      "Find out about the necessary documentation for listing your property with us.",
    buttonText: "Read More",
    disabled: true,
  },
  {
    name: "How can I contact an Estatein agent? ",
    description:
      "Discover the different ways you can get in touch with our experienced agents.",
    buttonText: "Read More",
    disabled: true,
  },
];
